import { WheatIcon } from "lucide-react";

interface ProductTitleBannerProps {
  productName: string;
}

const ProductTitleBanner: React.FC<ProductTitleBannerProps> = ({ productName }) => {
  return (
    <div className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 text-white p-6 rounded-xl shadow-xl flex items-center space-x-4">
      <div className="bg-white/20 p-3 rounded-lg">
        <WheatIcon size={32} className="text-white" />
      </div>
      <h2 className="text-4xl font-bold tracking-tight leading-tight">
        {productName.split("™").map((part, index, array) =>
          index < array.length - 1 ? (
            <span key={index}>
              {part}
              <sup className="text-sm">™</sup>
            </span>
          ) : (
            part
          )
        )}
      </h2>
    </div>
  );
};

export default ProductTitleBanner;
